// extracted by mini-css-extract-plugin
export var boldText = "_3o-4";
export var checkboxContainer = "_3o-6";
export var closeIcon = "_3o-g";
export var container = "_3o-0";
export var drawer = "_3o-8";
export var drawerContent = "_3o-9";
export var extraSmallText = "_3o-5";
export var fulfillmentGroupTable = "_3o-e";
export var largeText = "_3o-3";
export var loadingSpinnerContainer = "_3o-h";
export var mediumText = "_3o-2";
export var narrow = "_3o-f";
export var notificationLink = "_3o-j";
export var packageCheckIconContainer = "_3o-7";
export var slideoutHeaderContainer = "_3o-a";
export var slideoutModal = "_3o-c";
export var stickyHeaderWrapper = "_3o-b";
export var table = "_3o-i";
export var tableContainer = "_3o-d";
export var tertiaryText = "_3o-1";